import {
  HomeIcon,
  VideoCameraIcon,
  PencilSquareIcon,
  LightBulbIcon,
  CpuChipIcon,
  Squares2X2Icon,
  CalendarDaysIcon,
  SparklesIcon,
  SwatchIcon,
  PaintBrushIcon
} from '@heroicons/react/24/outline';

export const sidebarSections = [
  {
    title: 'Produção',
    items: [
      { icon: HomeIcon, label: 'Criar com IA', path: '/home' },
      { icon: PaintBrushIcon, label: 'Criação Manual', path: '/manual-create' },
      { icon: VideoCameraIcon, label: 'Vídeos', path: '/videos' },
      { icon: PencilSquareIcon, label: 'Editar imagem', path: '/edit-image' },
      { icon: LightBulbIcon, label: 'Conteúdos', path: '/contents' },
      { icon: CpuChipIcon, label: 'Treinar IA', path: '/train-ai' }
    ]
  },
  {
    title: 'Gestão',
    items: [
      { icon: Squares2X2Icon, label: 'Dashboard', path: '/dashboard' },
      { icon: CalendarDaysIcon, label: 'Agendamento', path: '/scheduling' }
    ]
  },
  {
    title: 'Marketing',
    items: [
      { icon: SparklesIcon, label: 'Campanhas', path: '/campaigns' },
      { icon: SwatchIcon, label: 'Identidade visual', path: '/brand-identity' }
    ]
  }
];
